// extracted by mini-css-extract-plugin
module.exports = {"largeGridList":"ProjectViewItemList_largeGridList__23Qtk"};